import React from "react";
import { motion, useReducedMotion } from "framer-motion";
import { CogIcon, SaladIcon } from "lucide-react";
const EASE = [0.23, 1, 0.32, 1] as const;
function Bar({
  value,
  color,
  delay
}: {
  value: number;
  color: string;
  delay: number;
}) {
  return <div className="h-3 w-full overflow-hidden rounded-full bg-cream-dark" data-id="element-24" data-mp="3qtsk2igd0s9n">
      <motion.div className={`h-full rounded-full ${color}`} initial={{
      width: "0%"
    }} animate={{
      width: `${value}%`
    }} transition={{
      duration: 0.3,
      delay,
      ease: EASE
    }} data-id="element-25" data-mp="3ls37gydho6jg" />
    </div>;
}
export function DigestionEffortVisual() {
  const reduce = useReducedMotion();
  const spin = (dir: 1 | -1, duration: number) => reduce ? {} : {
    animate: {
      rotate: 360 * dir
    },
    transition: {
      duration,
      repeat: Infinity,
      ease: "linear"
    }
  };
  return <figure className="rounded-2xl bg-white p-5" aria-label="Una cena liviana en calorías puede exigir mucho trabajo digestivo de noche" data-id="element-26" data-mp="2y1z66xnrwivm">
      <div className="grid grid-cols-2 gap-4 sm:gap-6" data-id="element-27" data-mp="2t60lpl5kfl0h">
        <div className="flex flex-col" data-id="element-28" data-mp="6wn8fdw303tj">
          <div className="flex h-20 items-center justify-center rounded-xl bg-olive-100" data-id="element-29" data-mp="6vlmgedj1wx1">
            <SaladIcon className="h-10 w-10 text-olive-600" aria-hidden="true" data-id="element-30" data-mp="bpptsyqpg6yn" />
          </div>
          <p className="mt-3 font-serif text-base font-semibold text-cocoa" data-id="element-31" data-mp="3u48rt590t0vf">Cena “liviana”</p>
          <p className="mt-0.5 text-xs text-cocoa-soft" data-id="element-32" data-mp="2wmlt5ytwmbe">Lo que ves en el plato</p>
          <div className="mt-auto pt-4" data-id="element-33" data-mp="qn0emyp8mp71">
            <p className="mb-1.5 text-xs font-medium text-cocoa-soft" data-id="element-34" data-mp="qjup5icp5las">Calorías</p>
            <Bar value={22} color="bg-olive-600" delay={0.1} data-id="element-35" data-mp="umhhdkda588i" />
          </div>
        </div>

        <div className="flex flex-col" data-id="element-36" data-mp="gn9hsqd7fy3s">
          <div className="relative flex h-20 items-center justify-center overflow-hidden rounded-xl bg-coral-100" data-id="element-37" data-mp="lmcbxfrncjwz">
            <motion.span className="absolute left-[30%] top-3" {...spin(1, 3)} data-id="element-38" data-mp="31dh12naq54fh">
              <CogIcon className="h-11 w-11 text-coral-600" aria-hidden="true" data-id="element-39" data-mp="36cjvzewzpu9q" />
            </motion.span>
            <motion.span className="absolute left-[52%] top-9" {...spin(-1, 2)} data-id="element-40" data-mp="2magw5knctvf3">
              <CogIcon className="h-8 w-8 text-rose-600" aria-hidden="true" data-id="element-41" data-mp="2i93r3cs35w98" />
            </motion.span>
          </div>
          <p className="mt-3 font-serif text-base font-semibold text-cocoa" data-id="element-42" data-mp="2dhvhogqraaw2">Trabajo digestivo</p>
          <p className="mt-0.5 text-xs text-cocoa-soft" data-id="element-43" data-mp="28jkayevrcgi2">Lo que tu cuerpo hace de noche</p>
          <div className="mt-auto pt-4" data-id="element-44" data-mp="23jz8vvlajs14">
            <p className="mb-1.5 text-xs font-medium text-cocoa-soft" data-id="element-45" data-mp="23l0lw5lvaolh">Esfuerzo</p>
            <Bar value={92} color="bg-coral-600" delay={0.35} data-id="element-46" data-mp="1ykuyj1mmro97" />
          </div>
        </div>
      </div>
      <figcaption className="mt-4 border-t border-blush-100 pt-3 text-center text-sm text-cocoa" data-id="element-47" data-mp="1ukkjkzgv1ni7">
        Frío + crudo + estrés = <span className="font-semibold text-coral-600" data-id="element-48" data-mp="1pm0xmz29obpu">más fermentación, gases y pesadez</span>
      </figcaption>
    </figure>;
}